export default __webpack_public_path__ + "static/media/cross-dark.754fc232.svg";